// frontend/src/components/games/tetris/tetrisConstants.ts

export const BOARD_WIDTH = 10;
export const BOARD_HEIGHT = 20;

export const BASE_DROP_MS = 800;
export const MIN_DROP_MS = 120;
export const DROP_MS_PER_LEVEL = 60;
export const LINES_PER_LEVEL = 10;

/** Klasik puanlama: temizlenen satır sayısına göre, seviyeyle çarpılır. */
export const LINE_CLEAR_SCORES: Record<number, number> = {
  1: 100,
  2: 300,
  3: 500,
  4: 800,
};

export const SOFT_DROP_SCORE = 1;
export const HARD_DROP_SCORE_PER_ROW = 2;
